<script>
    import { push, link, location } from 'svelte-spa-router';
    import { j } from '../../helpers.js';

    function jumpTo(e) {
        let scrollToElem;
        scrollToElem = e.target.getAttribute("href");

        if ($location === '/contact') {
            push('/');
            setTimeout(() => {
                j(scrollToElem); 
            }, 3);
        } else {
            j(scrollToElem); 
        }
    }
</script>

<footer class="container p-absolute footer">
    <div class="columns">
        <div class="column col-12 text-center">
            <a href="#home" title="Home" class="footer__link" on:click|preventDefault={ jumpTo }>Home</a>
            <a href="#about" title="About" class="footer__link" on:click|preventDefault={ jumpTo }>About</a>
            <a href="#portfolio" title="Portfolio" class="footer__link" on:click|preventDefault={ jumpTo }>Portfolio</a>
            <a use:link href="/contact" title="Contact" class="footer__link">Contact</a>
        </div>
    </div>
</footer>

<style lang="scss">
    .footer{
        padding-top: 25px;
        padding-bottom: 25px;
        bottom: 0;
        left: 0;
        right: 0;
        &__link{
            margin-left: 0.5rem;
            margin-right: 0.5rem;
        }
    }
</style>